import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Text, Button, Popover, Box } from '@radix-ui/themes';
import Trainer from 'components/classroom/components/backup/Trainer'; // Assuming this is a custom component
import TableElement from 'components/classroom/components/TableElement';
import ImageComponent from 'components/classroom/components/ImageComponent';
import { RootState } from 'store';
import circle1 from '../../../assets/images/circle1.png';
import expand from '../../../assets/images/expand.png';
import collapse from '../../../assets/images/collapse.png'
import TableElementNew from 'components/classroom/components/TableElementNew';
import { IoExpandOutline } from 'react-icons/io5';
import { HiOutlineUserGroup } from 'react-icons/hi';
import { BsHouseDown } from 'react-icons/bs';
import { AiOutlineFullscreenExit } from 'react-icons/ai';
import ParticipantExpandedTable from 'components/classroom/components/backup/ParticipantExpandedTable';
import { User } from 'models/User';
import store from "store";
import { updateAudioByTable, updateGdAudioByTable } from 'utils/StreamingHelperFunctions';
import briefIcons from "../../../assets/images/BriefIcons.png";
import { updateLiveStreamSettings } from 'store/reducers/livestreamSettings';

const elementStyle = {
    height: 100,
    width: 88,
    borderRadius: 8,
};

const Table = ({ onPressExpanded, groupLeaderEmail, name, users, handleExpend, gdActivityData, onBrief }) => {
    const dispatch = useDispatch();
    const { trainer } = useSelector((state: RootState) => state.live.settings);
    const [view, setView] = useState(true);

    const groupLeaderEmailFetch = (email) => {
        if (groupLeaderEmail) {
            const groupLeader = groupLeaderEmail
                .flatMap(group => group.seats)
                .find(seat => seat.participant_email === email && seat.group_leader);
            return groupLeader ? groupLeader.participant_email : null;
        }
        return null;
    };

    return (
        <div className="w-full flex flex-col items-center">
            {/* Top row */}
            <div className="flex flex-row">
                {users && users[2]?.participant_email === 'trainer@vtt' ? (
                    <Trainer
                        name={trainer.fullname}
                        trainerTableName="On Table 1"
                    />
                ) : users && (users[2]?.email || users[2]?.participant_email) !== undefined ? (
                    <div className="h-full w-full">
                        <TableElementNew
                            elementStyle={elementStyle}
                            onPress={() => console.log('hakuna matata')}
                            userData={users && users[2]}
                            hideKebab={true}
                            groupLeaderEmail={groupLeaderEmailFetch(users[2].participant_email)}
                            isExpandedView={false}
                        />
                    </div>
                ) : null}

                {/* {users && users[0] && <div className="px-2"></div>} */}

                {users && users[1]?.participant_email === 'trainer@vtt' ? (
                    <Trainer
                        name={trainer.fullname}
                        trainerTableName="On Table 1"
                    />
                ) : users && (users[1]?.email || users[1]?.participant_email) !== undefined ? (
                    <div className="h-full w-full">
                        <TableElementNew
                            elementStyle={elementStyle}
                            onPress={() => { }}
                            userData={users && users[1]}
                            hideKebab={true}
                            groupLeaderEmail={groupLeaderEmailFetch(users[1].participant_email)}
                            isExpandedView={false}
                        />
                    </div>
                ) : null}
            </div>
            {/* Middle section */}
            <div className="flex flex-row w-full items-center justify-center">
                {/* Left hand side */}
                <div>
                    {users && users[4]?.participant_email === 'trainer@vtt' ? (
                        <Trainer
                            name={trainer.fullname}
                            trainerTableName="On Table 1"
                        />
                    ) : users && (users[4]?.email || users[4]?.participant_email) !== undefined ? (
                        <div className="h-full w-full">
                            <TableElementNew
                                elementStyle={elementStyle}
                                onPress={() => { }}
                                userData={users && users[4]}
                                hideKebab={true}
                                groupLeaderEmail={groupLeaderEmailFetch(users[4].participant_email)}
                                isExpandedView={false}
                            />
                            {/* <Text className="text-white mt-1 text-center text-sm truncate">
                                {users && users[4]?.name || users && users[4]?.participant_name}
                            </Text> */}
                        </div>
                    ) : null}

                    {/* {users && users[0] && <div className="h-[4px] w-[88px]"></div>} */}

                    {users && users[6]?.participant_email === 'trainer@vtt' ? (
                        <Trainer
                            name={trainer.fullname}
                            trainerTableName="On Table 1"
                        />
                    ) : users && (users[6]?.email || users[6]?.participant_email) !== undefined ? (
                        <div className="h-full w-full">
                            <TableElementNew
                                elementStyle={elementStyle}
                                onPress={() => { }}
                                userData={users[6]}
                                hideKebab={true}
                                groupLeaderEmail={groupLeaderEmailFetch(users[6].participant_email)}
                                isExpandedView={false}
                            />
                        </div>
                    ) : null}
                </div>

                {/* Table view */}
                {/* <div className="flex items-center justify-center bg-[#545455] rounded-full relative m-4 h-full w-full border-[1px] border-[#767676]">
                    <div className="bg-[#545455] shadow-md h-full w-full rounded-full flex items-center justify-center border-[1px] border-[#5F488A] -mt-1">
                        <ImageComponent
                            source={circle1}
                            style={undefined}
                            height={10}
                            width={10}
                            mode="contain"
                        />
                        <div className="flex flex-col items-center px-8 py-1 bg-[#363e70] rounded-[40px] absolute bottom-20">
                            <Text className="font-bold text-white text-[13px]">Discussion</Text>
                            <Text className="font-bold text-white text-[14px]">{name}</Text>
                        </div>
                        <Button
                            variant="ghost"
                            onClick={() => {
                                onPressExpanded();
                                handleExpend(users, name);
                            }}
                            style={{ left: '4.5rem' }}
                            className="mt-2 h-6 w-6 flex items-center justify-center absolute bottom-8 left-28"
                        >
                            <ImageComponent mode='contain' source={expand} style={undefined} />
                        </Button>
                    </div>
                </div> */}
                <div className="rounded m-2 mobile:h-[11rem] h-[16rem] w-48 mobile:w-32">

                    <div className="flex flex-col h-full justify-center items-center rounded-[32px] bg-[#24272C] border border-[#302D3F] shadow-[inset_-6px_-6px_12px_rgba(255,255,255,0.25),_6px_6px_12px_rgba(0,0,0,0.25)] ">
                        <div>
                            <div className="mobile:text-xs bg-[#24272C] text-white py-1 px-4 rounded-lg flex shadow-[inset_-6px_-6px_12px_rgba(255,255,255,0.25),_6px_6px_12px_rgba(0,0,0,0.25)]">
                                {name}
                                <Popover.Root>
                                    <Popover.Trigger>
                                        {/* <span className="py-1 pl-2">
              <CiMenuKebab />
            </span> */}
                                    </Popover.Trigger>
                                    <Popover.Content>
                                        <Box grow="1">
                                            <Popover.Close>
                                                <div>
                                                    <div className="flex space-x-2 text-white">
                                                        <div className="py-1">
                                                            <HiOutlineUserGroup color="white" />
                                                        </div>
                                                        <p>Talk to this Group</p>
                                                    </div>
                                                    <div className="flex space-x-2 text-white">
                                                        <div className="py-1">
                                                            <BsHouseDown color="white" />
                                                        </div>
                                                        <p>Move to this Group</p>
                                                    </div>
                                                </div>
                                            </Popover.Close>
                                        </Box>
                                    </Popover.Content>
                                </Popover.Root>
                            </div>
                        </div>
                        <div
                            className="font-bold mt-5 text-xl text-white"
                            onClick={() => {
                                onPressExpanded();
                                handleExpend(users, name);
                            }}
                        >
                            <IoExpandOutline />
                        </div>
                    </div>
                </div>

                {/* Right hand side */}
                <div>
                    {users && users[5]?.participant_email === 'trainer@vtt' ? (
                        <Trainer
                            name={trainer.fullname}
                            trainerTableName="On Table 1"
                        />
                    ) : users && (users[5]?.email || users[5]?.participant_email) !== undefined ? (
                        <div className="h-full w-full">
                            <TableElementNew
                                elementStyle={elementStyle}
                                onPress={() => { }}
                                userData={users[5]}
                                hideKebab={true}
                                groupLeaderEmail={groupLeaderEmailFetch(users[5].participant_email)}
                                isExpandedView={false}
                            />
                        </div>
                    ) : null}

                    {/* {users && users[0] && <div className="h-[4px] w-[88px]"></div>} */}

                    {users && users[7]?.participant_email === 'trainer@vtt' ? (
                        <Trainer
                            name={trainer.fullname}
                            trainerTableName="On Table 1"
                        />
                    ) : users && (users[7]?.email || users[7]?.participant_email) !== undefined ? (
                        <div className="h-full w-full">
                            <TableElementNew
                                elementStyle={elementStyle}
                                onPress={() => { }}
                                userData={users[7]}
                                hideKebab={true}
                                groupLeaderEmail={groupLeaderEmailFetch(users[7].participant_email)}
                                isExpandedView={false}
                            />
                        </div>
                    ) : null}
                </div>
            </div>

            {/* Bottom row */}
            <div className="flex flex-row items-center mb-4">
                {users && users[3]?.participant_email === 'trainer@vtt' ? (
                    <Trainer
                        name={trainer.fullname}
                        trainerTableName="On Table 1"
                    />
                ) : users && (users[3]?.email || users[3]?.participant_email) !== undefined ? (
                    <div className="h-full w-full">
                        <TableElementNew
                            elementStyle={elementStyle}
                            onPress={() => { }}
                            userData={users[3]}
                            hideKebab={true}
                            groupLeaderEmail={groupLeaderEmailFetch(users[3].participant_email)}
                            isExpandedView={false}
                        />
                    </div>
                ) : null}

                {/* {users && users[0] && <div className="px-2"></div>} */}

                {users && users[0]?.participant_email === 'trainer@vtt' ? (
                    <Trainer
                        name={trainer.fullname}
                        trainerTableName="On Table 1"
                    />
                ) : users && (users[0]?.email || users[0]?.participant_email) !== undefined ? (
                    <div className="h-full w-full">
                        <TableElementNew
                            elementStyle={elementStyle}
                            onPress={() => { }}
                            userData={users[0]}
                            hideKebab={true}
                            groupLeaderEmail={groupLeaderEmailFetch(users[0].participant_email)}
                            isExpandedView={false}
                        />
                    </div>
                ) : null}
            </div>
        </div>
    );
};

const ViewGDBriefButton = ({ activityData, onBrief }) => {
    const profileData = useSelector((state: any) => state?.auth?.user);
    const myEmail = profileData?.email?.toLowerCase();

    if (!activityData || !myEmail) return null;

    const { brief_type, brief_verbal, brief_group_verbal, case: groups = [] } = activityData;

    const myGroup = groups.find((group: any) =>
        group.seats.some((seat: any) =>
            seat.participant_email?.toLowerCase() === myEmail
        )
    );

    if (!myGroup) return null;

    const myGroupIndex = groups.findIndex((g: any) => g.table_name === myGroup.table_name);

    let briefContent = '';
    let briefType = 'url'; // default to url

    if (brief_type === 'single' && brief_verbal) {
        briefContent = brief_verbal;
        // Check if it's text content (for single brief)
        if (!brief_verbal.startsWith('http') && !brief_verbal.includes('.')) {
            briefType = 'text';
        }
    }
    else if (
        brief_type === 'group' &&
        Array.isArray(brief_group_verbal) &&
        myGroupIndex >= 0 &&
        brief_group_verbal[myGroupIndex]?.file_url
    ) {
        const briefItem = brief_group_verbal[myGroupIndex];
        briefContent = briefItem.file_url;
        // Use the type from the data structure
        briefType = briefItem.type || 'text'; // default to text for group briefs
    }

    if (!briefContent) return null;

    const handleClick = () => {
        onBrief({
            attachment_url: briefContent,
            activityData,
            myGroupTable: myGroup.table_name,
            attachment_type: briefType,
        });
    };

    return (
        <button
            onClick={handleClick}
            className="absolute left-2 top-5 z-[999999] bg-[rgba(33,32,37,0.7)] flex justify-center items-center p-1 rounded"
        >
            <div className="animate-pulse">
                <img
                    src={briefIcons}
                    alt="Brief"
                    className="h-[2vh] w-[2vh] object-contain"
                />
            </div>
        </button>
    );
};


const ConfRoom = ({ users, name, gl, table, roomClient, isTrainerPresent, gdActivityData, onBrief, timer }) => {
    console.log('GD1234 gdActivityData', gdActivityData)
    console.log('GD1234 table', table)
    console.log('GD1234 users', users)
    const [isExpandedView, setIsExpandedView] = useState(false);
    const [groupLeaderEmail, setGroupLeaderEmail] = useState('false');
    const [groupLeaderUpdated, setGroupLeaderUpdated] = useState();
    const [expandData, setExpandData] = useState([]);
    const [participantData, setParticipantsData] = useState([]);
    const { trainer } = useSelector((state: RootState) => state.live.settings);
    const profileData = useSelector((state: any) => state?.auth?.user as User);
    const dispatch = useDispatch();
    const consumerPeersIds: any[] = useSelector(
        (state: RootState) => state.live.settings.consumerPeers
    );
    const [localUsers, setLocalUsers] = useState(users || []);
    const [minutes, setMinutes] = useState(0);
    const [seconds, setSeconds] = useState(0);
    const [isActive, setIsActive] = useState(false);

    // Initialize timer when prop changes
    useEffect(() => {
        console.log('GD ALOT TIME CONF', timer)

        if (timer && timer > 0) {
            setMinutes(timer);
            setSeconds(0);
            setIsActive(true);
        }
    }, [timer]);

    // Countdown logic
    useEffect(() => {
        let interval = null;

        if (isActive) {
            interval = setInterval(() => {
                if (seconds > 0) {
                    setSeconds(seconds - 1);
                } else if (minutes > 0) {
                    setMinutes(minutes - 1);
                    setSeconds(59);
                } else {
                    // Timer completed
                    setIsActive(false);
                    clearInterval(interval);
                }
            }, 1000);
        } else if (!isActive && minutes !== 0 && seconds !== 0) {
            clearInterval(interval);
        }

        return () => clearInterval(interval);
    }, [isActive, minutes, seconds]);
    useEffect(() => {
        const findPeers = async () => {
            if (localUsers.length > 0 && profileData.email) {
                const currentState = roomClient?._store?.getState?.();
                const currentConsumers =
                    currentState?.live?.settings?.consumers || {};

                const currentAudioConsumers = Object.values(currentConsumers).filter(
                    (c: any) =>
                        (c.track?.kind || c.kind) === "audio" &&
                        c.track?.readyState === "live"
                );

                const audioConsumerIds = currentAudioConsumers.map((a: any) => a.peerId);
                const muteStates = updateGdAudioByTable(
                    localUsers,
                    profileData.email,
                    "trainer@vtt",
                    audioConsumerIds
                );
                console.log('muteStates: bye', muteStates);
                roomClient.consumerResumeRoleplayersAudio(muteStates.muteStates);
            }
        };
        findPeers();
    }, [consumerPeersIds, localUsers]);

    useEffect(() => {
        setLocalUsers(users || []);
    }, [users]);

    // 👇 When trainer info comes in from props
    useEffect(() => {
        // Trainer joined a group
        if (isTrainerPresent && Object.keys(isTrainerPresent).length > 0) {
            setLocalUsers((prevUsers: any[]) =>
                prevUsers.map((group) => {
                    if (group.table_name === isTrainerPresent.table_name) {
                        const alreadyPresent = group.seats.some(
                            (seat: any) =>
                                seat.participant_email === isTrainerPresent.participant_email
                        );
                        if (alreadyPresent) return group;

                        return {
                            ...group,
                            seats: [...group.seats, isTrainerPresent],
                        };
                    }
                    return group;
                })
            );
        }

        // Trainer left → remove from all groups
        else {
            console.log("Trainer left — removing from all groups");

            setLocalUsers((prevUsers: any[]) =>
                prevUsers.map((group) => ({
                    ...group,
                    seats: group.seats.filter(
                        (seat: any) => seat.participant_email !== "trainer@vtt"
                    ),
                }))
            );
        }
    }, [isTrainerPresent]);

    const handleExpandedClose = () => {
        setExpandData([]);
    };

    useEffect(() => {
        if (users && profileData?.email) {
            const sortedUsers = [...users].sort((a, b) => {
                const aHasUser = a.seats?.some(
                    (seat: any) => seat.participant_email === profileData.email
                );
                const bHasUser = b.seats?.some(
                    (seat: any) => seat.participant_email === profileData.email
                );

                if (aHasUser && !bHasUser) return -1;
                if (!aHasUser && bHasUser) return 1;
                return 0;
            });

            setGroupLeaderUpdated(gl);
            setParticipantsData(isExpandedView ? expandData : sortedUsers);
            dispatch(updateLiveStreamSettings({ groupLeaderNew: gl }));
        } else {
            setGroupLeaderUpdated(gl);
            setParticipantsData(isExpandedView ? expandData : users);
            dispatch(updateLiveStreamSettings({ groupLeaderNew: gl }));
        }
    }, [isExpandedView, gl, users, expandData, profileData?.email]);


    return (
        <div className="w-full flex flex-col">
            {users && users.length > 0 ? (
                <div className="flex items-center justify-start">
                    {isExpandedView ? (
                        <div className="w-full text-2xl text-white justify-center mobile:justify-center flex  m-2 ">
                            <div className="bg-gray-600 p-2 rounded-lg opacity-50">
                                <span className='text-white' onClick={() => {
                                    setIsExpandedView(false);
                                    handleExpandedClose();
                                }} >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="white">
                                        <path d="M9.33464 6.66602L13.3346 2.66602M9.33464 6.66602H12.3346M9.33464 6.66602V3.66602M2.66797 2.66602L6.66797 6.66602M6.66797 6.66602V3.66602M6.66797 6.66602H3.66797M9.33464 9.33268L13.3346 13.3327M9.33464 9.33268V12.3327M9.33464 9.33268H12.3346M6.66797 9.33268L2.66797 13.3327M6.66797 9.33268H3.66797M6.66797 9.33268V12.3327" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </span>
                                {/* <AiOutlineFullscreenExit onClick={() => {
                                    setIsExpandedView(false);
                                    handleExpandedClose();
                                }} /> */}
                            </div>
                        </div>
                        // <div className="flex flex-col items-center">
                        //     <Button
                        //         variant="ghost"
                        //         onClick={() => {
                        //             setIsExpandedView(false);
                        //             handleExpandedClose();
                        //         }}
                        //         className="absolute left-10 top-12"
                        //     >
                        //         <ImageComponent mode='contain' height={3} width={6} source={collapse} style={undefined} />
                        //     </Button>
                        // </div>
                    ) : null}
                </div>
            ) : null}
            <div className="relative flex mobile:flex-col flex-row items-center w-full mt-2 mb-4">
                {/* Center Section - Properly centered with absolute positioning */}
                <div className="absolute left-1/2 -translate-x-1/2 mobile:relative mobile:left-0 mobile:translate-x-0 mobile:order-1 mobile:w-full mobile:flex mobile:justify-center mobile:mb-2">
                    <div className="bg-[rgba(33,32,37,0.8)] rounded-lg py-2 px-4 gap-4 border border-[#545455] flex flex-row items-center justify-center">
                        <span className="text-[#E9BE50] text-[10px] font-bold">
                            Discussions in Progress
                        </span>
                        <div className="h-[8px] w-[8px] rounded-full bg-[#43A047] border border-[#E9BE50]"></div>
                    </div>
                </div>

                {/* Timer Section */}
                <div className="ml-auto me-4 mobile:ml-0 mobile:me-0 mobile:order-2 mobile:w-full mobile:flex mobile:justify-center">
                    <div className="bg-[rgba(33,32,37,0.8)] rounded-lg py-2 px-3 border border-[#545455] flex flex-row items-center justify-center gap-2">
                        <img src="./img/img4.png" alt="timer" className="w-4 h-4" />
                        <div className="flex flex-row items-center justify-center gap-1">
                            <span className="text-[#E9BE50] text-[10px]">{minutes}m</span>
                            <span className="text-[#E9BE50] text-[10px]">{seconds}s</span>
                        </div>
                    </div>
                </div>
            </div>
            <ViewGDBriefButton
                activityData={gdActivityData}
                onBrief={onBrief}
            />

            {participantData && participantData.length > 0 ? (
                <div className="w-full flex items-center overflow-y-auto justify-center">
                    {!isExpandedView ? (
                        <div>
                            {participantData.map((v, i) => (
                                <div key={i} className="w-full flex">
                                    <Table
                                        users={v?.seats}
                                        // isExpandedView={isExpandedView}
                                        onPressExpanded={() => setIsExpandedView(true)}
                                        name={v?.table_name}
                                        groupLeaderEmail={groupLeaderUpdated}
                                        handleExpend={(trainee, tableName) => setExpandData(trainee)}
                                        gdActivityData={gdActivityData}
                                        onBrief={onBrief}
                                    />
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="w-full h-full flex flex-wrap justify-center">
                            <ParticipantExpandedTable data={participantData} />
                            {/* {participantData.map((item, index) => (
                                <div key={item.id} className="my-2 px-2.5">
                                    <TableElementNew
                                        elementStyle={elementStyle}
                                        onPress={() => { }}
                                        userData={item}
                                        isExpandedView={true}
                                        hideKebab={true}
                                        groupLeaderEmail={groupLeaderEmail}
                                    />
                                </div>
                            ))} */}
                        </div>
                    )}
                </div>
            ) : null}
        </div>
    );
};

export default ConfRoom;